var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnmute(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 489.9 489.9",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m268.9 70.25c-4.9 0-9.8 1.3-14.2 3.8-0.3 0.2-0.6 0.3-0.8 0.5l-100.1 69.2h-80.5c-40.4 0-73.3 32.9-73.3 73.3v55.6c0 40.4 32.9 73.3 73.3 73.3h84.5l95.9 69.2c0.3 0.2 0.7 0.5 1 0.7 4.3 2.5 9.2 3.8 14.2 3.8 7.4 0 14.4-2.8 19.7-7.9 5.6-5.4 8.7-12.6 8.7-20.4v-292.7c0-15.7-12.7-28.4-28.4-28.4zm3.9 321c0 1.1-0.4 2-1.1 2.8-0.7 0.7-1.8 1.1-2.7 1.1-0.5 0-1-0.1-1.5-0.3l-98.4-71.1c-2.1-1.5-4.6-2.3-7.2-2.3h-88.6c-26.9 0-48.8-21.9-48.8-48.8v-55.6c0-26.9 21.9-48.8 48.8-48.8h84.3c2.5 0 4.9-0.8 7-2.2l102.7-71c0.5-0.3 1.1-0.4 1.6-0.4 1.6 0 3.9 1.2 3.9 3.9v292.7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m486.1 171.35c-4.8-4.8-12.5-4.8-17.3 0l-56.3 56.3-56.3-56.3c-4.8-4.8-12.5-4.8-17.3 0s-4.8 12.5 0 17.3l56.3 56.3-56.3 56.3c-4.8 4.8-4.8 12.5 0 17.3 2.4 2.4 5.5 3.6 8.7 3.6s6.3-1.2 8.7-3.6l56.3-56.3 56.3 56.3c2.4 2.4 5.5 3.6 8.7 3.6s6.3-1.2 8.7-3.6c4.8-4.8 4.8-12.5 0-17.3l-56.5-56.3 56.3-56.3c4.7-4.8 4.7-12.5 0-17.3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnmute);
export default __webpack_public_path__ + "static/media/unmute.bb57dda4d9e6c09bbbbf97e0302b060d.svg";
export { ForwardRef as ReactComponent };